import { render, staticRenderFns } from "./AttachEpg.vue?vue&type=template&id=61ffdfa6&v-on-clickaway=cancel()&"
import script from "./AttachEpg.vue?vue&type=script&lang=ts&"
export * from "./AttachEpg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports